import React from "react";
import { LangContextProvider } from "./LangContext";

const ContextList = [{ name: "Lang", context: LangContextProvider }];

function Context(props) {
  let output = props.children;
  ContextList.forEach((contextInfo) => {
    output = <contextInfo.context>{output}</contextInfo.context>;
  });
  return output;
}

export { LangContextProvider };

export default Context;
